export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11782.be00b71f.jpg";